
class TimeZonesService {
    constructor ($resource) {
        this.resource = $resource(window.config.SYSTEM_URL + window.config.API_URL + '/settings/time-zones');
    }

    getAll = () => {
        return this.resource.query();
    };
}

export {
    TimeZonesService
};
